import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RouterContext from 'react-router/lib/RouterContext';

import RedialContext from 'utils/redial/RedialContext';
import { noop } from 'utils/func';

import LoadingMask from 'apps/loaders/containers/LoadingMask';
import BrowserSpecific from 'apps/browserSpecific/BrowserSpecific';
import MediaQueriesProvider from 'utils/mediaQueries/MediaQueriesProvider';
import LoginEventSender from 'apps/analytics/containers/LoginEventSender';

import PageView from 'apps/analytics/components/PageView';
// default react-router's Router implementation
const defaultRender = (props) => (
  <RouterContext {...props} />
);

export default class App extends PureComponent {
  static propTypes = {
    // RouterContext default props
    router: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired,
    components: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    render: PropTypes.func,
    onError: PropTypes.func, // (err) => {}
    // config for RedialContext, grouped; optional as with server-side rendering it's not required
    redialConfig: PropTypes.object,
    redialConfigStore: PropTypes.object,
    stateSupplier: PropTypes.func,
  };

  state = {
    loading: false,
  }

  static defaultProps = {
    render: defaultRender,
    onError: noop,
  };

  UNSAFE_componentWillMount() {
    this.displayContent(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.displayContent(nextProps);
  }

  displayContent(nextProps) {
    const renderProps = { ...nextProps };
    this.displayAsMainContent(renderProps);
  }

  displayAsMainContent(props) {
    const { redialConfig, redialConfigStore, render, location, stateSupplier, ...routeProps } = props;

    const renderWithAnalytics = (renderProps) => (
      <PageView location={location} stateSupplier={stateSupplier}>
        {render(renderProps)}
        <LoginEventSender />
      </PageView>
    );

    this.mainContent = (
      <RedialContext
        {...routeProps}
        {...redialConfig}
        render={renderWithAnalytics}
        location={location}
        onUpdate={this.handleRedialContextUpdate}
        store={redialConfigStore}
      />
    );
  }

  handleRedialContextUpdate = ({ loading }) => {
    this.setState({ loading });
  };

  render() {
    return (
      <MediaQueriesProvider>
        {this.mainContent}
        <LoadingMask loading={this.state.loading} />
        <BrowserSpecific />
      </MediaQueriesProvider>
    );
  }
}
